<div *ngIf="isLoading" class="w-100 h-100 text-center">
  <div class="row justify-content-center">
    <div class="spinner-border spinner  mt-5" style=" width: 6rem; height: 6rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>

<div class="container  align-items-center" *ngIf="!isLoading">
  <div class="text-center card-container  ">
    <div class="">
      <h1 class="underlineTitle cardHeader col-md-6 title text-left "><strong>Simulatietools</strong></h1>
      <div class="row row-cols-1 row-cols-md-3">
        <div class="col col-md-6">

          <div [routerLink]="['/', onderneming?.naam,'vaa']" class="simulatie row clickable">
            <div class="col-3  w-100 align-self-center">
              <div class="round align-self-center  round-lg d-flex" >
                <i class="fa fa-car mx-auto my-auto fa-2x" aria-hidden="true"></i>
              </div>
            </div>
            <div class=" col-9 text-left">
              <h3 class=" card-title">Bereken VAA bedrijfswagens</h3>
            </div>
          </div>
          <div [routerLink]="['/', onderneming?.naam,'cash4Bike']" class="simulatie row clickable">
            <div class="col-3  w-100 align-self-center">
              <div class="round align-self-center  round-lg d-flex" >
                <i class="fa fa-bicycle mx-auto my-auto fa-2x" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-9 text-left">
              <h3 class="card-title">Cash voor lease fiets</h3>
            </div>
          </div>
          <div [routerLink]="['/', onderneming?.naam,'holidayValue']" class="simulatie row clickable">
            <div class="col-3  w-100 align-self-center">
              <div class="round align-self-center  round-lg d-flex" >
                <i class="fa fa-plane mx-auto my-auto fa-2x" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-9 text-left">
              <h3 class="card-title">Cash voor vakantiedagen</h3>
            </div>
          </div>
<!-- 
          <div *ngIf="this.onderneming.naam == 'Accuria' || this.onderneming.naam == 'Bedrijf'  " [routerLink]="['/', onderneming?.naam,'koopkrachtpremie']" class="simulatie row clickable">
            <div class="col-3  w-100 align-self-center">
              <div class="round align-self-center  round-lg d-flex" >
                <i class="fa fa-shopping-cart mx-auto my-auto fa-2x" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-9 text-left">
              <h3 class="card-title">Koopkrachtpremie</h3>
            </div>
          </div> -->

         
           

           

         

        </div>
        <div class="col-md-6">
          
          <!-- <div [routerLink]="['/under-construction']" class="simulatie row clickable">
            <div class='col-3  w-100 align-self-center'>
              <div class='round align-self-center  round-lg d-flex' >
                <i class='fa fa-credit-card mx-auto my-auto fa-2x' aria-hidden='true'></i>
              </div>
            </div>
            <div class='col-9 text-left'>
              <h3 class='card-title'>Bruto - Netto</h3>
            </div>
          </div> -->
  

        <div [routerLink]="['/', onderneming?.naam,'aanwerfsimulator']" class="simulatie row clickable">
          <div class="col-3  w-100 align-self-center">
            <div class="round align-self-center  round-lg d-flex">
              <i class="fa fa-user-plus mx-auto my-auto fa-2x" aria-hidden="true"></i>
            </div>
          </div>
          <div class="col-9 text-left">
            <h3 class="card-title">Horeca aanwerf calculator</h3>
          </div>
        </div>
        
        <div *ngIf="this.onderneming.activeModules.opzegtermijn" [routerLink]="['/', onderneming?.naam,'opzegtermijn']" class="simulatie row clickable">
          <div class="col-3  w-100 align-self-center">
            <div class="round align-self-center  round-lg d-flex">
              <i class='fa fa-calendar mx-auto my-auto fa-2x' aria-hidden='true'></i>
            </div>
          </div>
          <div class="col-9 text-left">
            <h3 class="card-title">Opzegtermijn</h3>
          </div>
        </div>

        <div *ngIf="this.onderneming.linkLoonkost">
          <a href = "{{this.onderneming.linkLoonkost}}" class="simulatie row clickable">
            <div class='col-3  w-100 align-self-center'>
              <div class='round align-self-center  round-lg d-flex' >
                <i class='fa fa-link mx-auto my-auto fa-2x' aria-hidden='true'></i>
              </div>
            </div>
            <div class='col-9 text-left'>
              <h3 class='card-title'>Loonkost</h3>
            </div>
          </a>
        </div>
      
        
          <!-- <div [routerLink]="['/', onderneming?.naam,'cash4Car']" class="simulatie row clickable">
            <div class="col-3  w-100 align-self-center">
              <div class="round align-self-center  round-lg d-flex">
                <i class="fa fa-car mx-auto my-auto fa-2x" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-9 text-left">
              <h3 class="card-title">Cash4Car</h3>
            </div>
          </div> -->

          
          <div *ngIf="customLink?.link.trim() != ''">
            <a href={{customLink?.link}} target="_blank" class='simulatie row clickable'>
              <div class='col-3  w-100 align-self-center'>
                <div class='round align-self-center  round-lg d-flex' >
                  <i class='fa fa-link mx-auto my-auto fa-2x' aria-hidden='true'></i>
                </div>
              </div>
              <div class='col-9 text-left'>
                <h3 class='card-title'>{{customLink?.omschrijving}}</h3>
              </div>
            </a>
          </div>
         
        </div>


        
    </div>
  </div>
    
</div>
<div style="margin-top: 5vh; margin-bottom: 3vh; " >
  <div>
    <hr/>
  </div>
  <div style="float:right">
    © Developed by <a style="font-weight:bold;"href="https://www.solvh.be">Solvh</a>
  </div>
  
</div>
